import type { FetchProcessDetailsResponseData } from 'gcs-common/clients/api/entities/processes/processes-api-helpers';
import { convertPriceToString } from 'gcs-common/helper/processTextHelper';
import styles from './styles.module.scss';

interface ProductDetailProps {
  product: FetchProcessDetailsResponseData['items'][number];
}

const ProductDetail = (props: ProductDetailProps) => {
  const { product } = props;
  return (
    <div className={styles.productDetailWrapper}>
      <div className={styles.productDetail}>
        <div className={styles.productArticleNumber}>{product.ArticleNumber}</div>
        <div className={styles.productDescription}>
          <div>{product.ArticleDescription1}</div>
          <div>{product.ArticleDescription2}</div>
          <span>{`Listenpreis: ${convertPriceToString(product.GrossSalesPrice, product) || 'Nicht verfügbar'}`}</span>
          <span>{`Nettopreis: ${convertPriceToString(product.NettoSalesPrice, product) || 'Nicht verfügbar'}`}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
